module.exports = __webpack_public_path__ + "img/cgi.8204af56.svg";